import React, { useState, useEffect, useRef } from 'react';
// import header_B from '../assets/Header_2.jpg';
// import body_A from '../assets/Body_1.jpg';
// import body_C from '../assets/Body_3.jpg';
import '../App.css';
import FloatingButton from '../components/FloatingButton.js';
import PopUp from '../components/PopUp.js';
import { db } from '../common/firebaseSetup.js';
import { doc, collection, setDoc, Timestamp } from 'firebase/firestore';
import { Mixpanel } from '../common/Mixpanel.js';
import { faker } from "@faker-js/faker";
import { Checkbox, FormControlLabel, Typography } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import { motion } from "framer-motion";
import { pageVariants } from "../animation/variants.js";


function generateRandomName() {
  return faker.person.fullName(); // Generates a random full name
}

function Tryon() {
  // States for visibility
  const [isButtonVisible, setButtonVisibility] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  // Add a state to handle the phone number input
  const [phoneNumber, setPhoneNumber] = useState('');

  // Refs for each section
  const headerSectionRef = useRef(null); 
  const body1SectionRef = useRef(null);
  const body2SectionRef = useRef(null);
  const contactSectionRef = useRef(null);

  useEffect(() => {
    // Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'ViewContent');
    }

    const params = new URLSearchParams(window.location.search);
    const utmSource = params.get('utm_source') || 'unknown';
    const utmMedium = params.get('utm_medium') || 'unknown';
    const utmCampaign = params.get('utm_campaign') || 'unknown';
    const utmContent = params.get('utm_content') || 'unknown';
    const distinctId = Mixpanel.get_distinct_id(); // Retrieve the current distinct ID
    Mixpanel.identify(distinctId); // Identify the user with this ID
    const generatedName = generateRandomName(); // Generate the unique name

    Mixpanel.register_once({
      "$name": generatedName
    });

    Mixpanel.people.set_once({
      "$name": generatedName,
      "initial_utm_source": utmSource,
      "initial_utm_medium": utmMedium,
      "initial_utm_campaign": utmCampaign,
      "initial_utm_content": utmContent,
    });

    Mixpanel.register({
      "page": 'tryon', // This can be updated as the user navigates
      // other properties that might change
    });

    Mixpanel.people.set({
      "distinct_id": distinctId, 
      "utm_source": utmSource,
      "utm_medium": utmMedium,
      "utm_campaign": utmCampaign,
      "utm_content": utmContent,
      "lead_submission_completed": false,
      "number_of_lead_submissions": 0,
    });

    // Track the page view event for Mixpanel
    Mixpanel.track('view_landing_page');
  }, []);

  // Function to handle the tracking of section visibility
  const trackSection = (sectionName) => {
    Mixpanel.track(`scroll_${sectionName}`);
  };

  // For checking if FloatingButton should appear or not
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setButtonVisibility(!entry.isIntersecting);
      },
      {
        root: null, // observing with respect to the viewport
        threshold: 0.01, // callback fires when 1% of the target is visible
      }
    );

    if (contactSectionRef.current) {
      observer.observe(contactSectionRef.current);
    }

    return () => {
      if (contactSectionRef.current) {
        observer.unobserve(contactSectionRef.current);
      }
    };
  }, [contactSectionRef]);

  // Function to track event in which user views a certain section
  useEffect(() => {
    // Create an observer instance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionName = entry.target.dataset.section; // 'section1', 'section2', etc.
          const timeoutId = setTimeout(() => trackSection(sectionName), 1000);
          return () => clearTimeout(timeoutId);
        }
      });
    }, {
      root: null,
      threshold: 0.1 // Adjust as necessary
    });

    // Observing each section
    const sections = [headerSectionRef, body1SectionRef, body2SectionRef, contactSectionRef];
    sections.forEach((ref, index) => {
      if (ref.current) {
        ref.current.dataset.section = index === 3 ? 'lead' : `section${index + 1}`;
        observer.observe(ref.current);
      }
    });

    return () => {
      sections.forEach((ref) => {
        if (ref.current) observer.unobserve(ref.current);
      });
    };
  }, []);
  
  const scrollToBottom = () => {
    if (contactSectionRef.current) {
      // Calculate the bottom position of the contact-section
      const bottomOfContactSection = contactSectionRef.current.getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
  
      window.scrollTo({
        top: bottomOfContactSection,
        behavior: 'smooth'
      });
    }
  };

  const handleInputClick = () => {
    Mixpanel.track('click_textbox');
  };

  const handleFloatingButtonClick = () => {
    scrollToBottom();
    Mixpanel.track('click_sticky');
  };

  // Function to handle recording the number into a database (Google Spreadsheet)
  const handleRecordNumber = async () => {
    Mixpanel.track('click_submit');
    
    const trimmedPhoneNumber = phoneNumber.trim();
    if (trimmedPhoneNumber === '') {
      toast.error('전화번호를 입력해주세요');
      return;
    }
  
    // Check if the phone number is in the correct format
    const phoneNumberRegex = /^010-?\d{4}-?\d{4}$/;
    if (!phoneNumberRegex.test(trimmedPhoneNumber)) {
      toast.error('올바른 전화번호를 입력해주세요');
      return;
    }

    if (!isChecked) {
      toast(
        (t) => (
          <div className='toast'>
            개인정보 수집 및 이용에 동의해야 합니다
            <div className = 'toast_button' onClick={() => toast.dismiss(t.id)}>확인</div>
          </div>
        ),
        {
          id: 1,
        }
      );
      return;
    }

    let formattedPhoneNumber = trimmedPhoneNumber.replace(/-/g, ''); // Remove existing hyphens
    formattedPhoneNumber = formattedPhoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');

    // Create a new document reference with an auto-generated ID
    const docRef = doc(collection(db, 'contacts'));

    try {
      await setDoc(docRef, {
        phoneNumber: formattedPhoneNumber,
        timestamp: Timestamp.fromDate(new Date()) // Firestore Timestamp
      });

      console.log('Phone number saved successfully');
      setShowPopup(true);

      //Track CompleteRegistration event for Meta Pixel
      if (window.fbq) {
        window.fbq('track', 'CompleteRegistration');
      }
      
      // Mixpanel tracking
      Mixpanel.track('complete_submit');
      Mixpanel.people.set({
        "lead_submission_completed": true,
      });
      Mixpanel.people.increment("number_of_lead_submissions", 1);
    } catch (error) {
      console.error('Error saving phone number: ', error);
      alert('There was an error saving your number. Please try again.');
    }

    setPhoneNumber('');
    setButtonClicked(true);
    setTimeout(() => {
      setButtonClicked(false);
    }, 100);
  };

  const closePopup = () => {
    setShowPopup(false);
  };


  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      >
      <div className="image-container header" ref={headerSectionRef}>
        {/* <img src={header_B} alt="Image 1" /> */}
      </div>
      <div className="image-container body_1" ref={body1SectionRef}>
        {/* <img src={body_A} alt="Image 2" /> */}
      </div>
      <div className="image-container body_2" ref={body2SectionRef}>
        {/* <img src={body_C} alt="Image 3" /> */}
      </div>
      {isButtonVisible && !showPopup && <FloatingButton onClick={handleFloatingButtonClick} />}
      <div className="contact-section" ref={contactSectionRef}>   
        <div className="title-wrapper"> 
          <h1>나만의 AI 스튜디오<br/>헤이팝을 미리 만나보세요</h1>
          <h3>연락처를 남겨주시면 <br/>앱 출시 소식을 가장 먼저 알려드릴게요</h3>
        </div>
        <div className="input-wrapper"> 
          <input
            type="tel"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            placeholder="010-1234-5678"
            onClick={handleInputClick}
          />
          <button 
            onClick={handleRecordNumber}
            style={{ backgroundColor: buttonClicked ? '#6f00ff' : '#923DFF' }} // Change '#YourNewColor' to your desired color
          >
            제출하기
          </button>
        </div>
        <div className="checkbox-wrapper">
          <FormControlLabel 
            control=
            {<Checkbox 
              sx={{
                color: '#d5d5d5',
                '&.Mui-checked': {
                  color: '#cda6ff',
                },
                '& .MuiSvgIcon-root': 
                { fontSize: 20 }
              }}
              checked={isChecked}
              onChange={(e) => {
                setIsChecked(e.target.checked);
              }}
            />}
            label={
              <Typography 
                align = 'left'
                sx={{ fontSize: 12 }}>
                개인정보 수집 및 이용동의 (필수)
              </Typography>
            }
          />
          <a href="/policy/collection_and_use_info" className="privacy-link">약관 보기</a>
        </div>
      </div>
      <div className="footer">
        <div className="text-wrapper">
          <p>(주) 엔엑스엔랩스 | 대표 : 이재원</p>
          <br/>
          <p>대전광역시 서구 문정로 90번길 65</p>
          <p>nxn.ai.official@gmail.com</p>
          <br/>
          <p>Copyright @ NXN Labs Co.</p>
          <br/>
          <br/>
        </div>
        <div className="link-wrapper">
          <a href="/policy/privacy">개인정보처리방침</a>
        </div>
      </div>
      <PopUp show={showPopup} onClose={closePopup} />
      <Toaster position="top-center" />
    </motion.div>
  );
}

export default Tryon;
